import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AirplaneStyle,
  SeatMapsInt,
  SeatmapCollectionInt,
  SeatmapSectionInt, SeatmapRowInt
} from '@interfaces/*';
import { GlobalsService } from '@services/micro/globals.service';
import { PassengerService } from '@services/micro/passenger.service';
import { SeatsService } from '@services/seats.service';
import { Passenger } from '@app/models/micro/passenger.model';
import { Segment } from '@app/models/micro/segment.model';
import { Reservation } from '@app/models/micro';

@Component({
    selector: 'app-select-seat',
    templateUrl: './select-seat.component.html',
    styleUrls: ['./select-seat.component.scss'],
    standalone: false
})
export class SelectSeatComponent implements OnInit {
  selectedTrip: Segment;
  airplaneMap: null | SeatmapCollectionInt = null;
  seatMap: any;
  seatMapsInt: null | SeatMapsInt;
  seatMapSections: Array<SeatmapSectionInt> = [];
  finalAMapSec: Array<SeatmapSectionInt> = [];
  finalRowMapSec: SeatmapSectionInt
  rowsMapInt: Array<SeatmapRowInt> = [];
  rowmapInt: SeatmapRowInt;
  mapDiv: null | HTMLElement;
  showDiv: boolean;
  navTab: boolean;
  footerTab: boolean;
  airplane: string;
  passengers: Array<Passenger> = [];
  currentPassenger: Passenger;
  nextPosition = 0
  reservation: Reservation;
  sitcoachtoamplusrow: SeatmapRowInt;
  sitcoachtoprefer1: SeatmapRowInt;
  sitcoachtoprefer2: SeatmapRowInt;
  sitcoachtoprefer3: SeatmapRowInt;
  sitcoachtoprefer4: SeatmapRowInt;
  sitcoachtocoach: SeatmapRowInt;
  totalSeatsPassengers: number = 0;
  refreshCheck: boolean = false;
  indexSegment: number

  constructor(
    private router: Router,
    private seatsServ: SeatsService,
    private passengerSelect: PassengerService,
    private _global: GlobalsService,
  ) {
    this.showDiv = false;
    this.navTab = false;
    this.footerTab = false;

  }

  ngOnInit(): void {
    this.passengerSelect.setPositionCurrentPassenger(0)
    this.reservation = this._global.reservation;
    this.selectedTrip = this._global.getSelectedTrip();

    this.indexSegment = this.reservation.segments.findIndex(
      (element) => element.segmentCode === this.selectedTrip.segmentCode) + 1;
    // this.seatMap = this.global.getSeatMapInfo()
    this.seatMap = this._global.getSeatMapInfo();

    const cartId = this._global.getReservation().flightSummary.cartId;
    this.setSiteMap(cartId);
    this.passengers = this.passengerSelect.getPassengerSelection();
    this.currentPassenger = this.passengerSelect.getCurrentPassenger();
    this.nextPosition = this.passengerSelect.getPositionCurrentPassenger()
    this.passengers.map(x => {
      const seats = x.seats.filter(seat => seat.status == 3 && seat.segmentCode == this.selectedTrip.segmentCode);
      seats?.map(x => {
        this.totalSeatsPassengers += +x.cost;
      })
    });
  }

  onExit() {
    this.passengerSelect.setPositionCurrentPassenger(0)
    this.router.navigate(['/seat'])
  }

  sectionRow() {
    // const selectedtrip = this.global.getSelectedTrip()
    const selectedtrip = this._global.getSelectedTrip();
    this.finalAMapSec = this._global.getSeatMapInfo().find(m =>
      m.segment.segmentCode == selectedtrip.segmentCode).getseatInfo();

    return this.finalAMapSec;
  }

   createDummySeat(baseSeat, dummyIndex) {
  return {
    _meta: { class: "SeatmapSeat" },
    column: "Dummy",
    row: baseSeat.row,
    code: '', // Ej: 1D1, 1D2
    status: "UNAVAILABLE",
    choice: {

    },
    discountPrice: null,
    travelerOffers: [],
    seatId: '',
    section: '',
    assigned: false,
    currentAssigned: false,
    cost: 0,
    sectionInfo: ''
  };
}

insertDummySeatsInSection(sections) {
  return sections.map(section => {
    if (section.code !== "FIRST_CLASS") return section;

    // usamos map para reconstruir cada fila
    const newRows = section.rows._collection.map(row => {
      const newSeats = row.seats._collection.flatMap(seat => {
        const seatsWithDummy = [seat];

        if (seat.column === "A") seatsWithDummy.push(this.createDummySeat(seat, "1"));
        if (seat.column === "E") seatsWithDummy.push(this.createDummySeat(seat, "2"));

        return seatsWithDummy;
      });

      return {
        ...row,
        seats: {
          ...row.seats,
          _collection: newSeats
        }
      };
    });

    return {
      ...section,
      rows: {
        ...section.rows,
        _collection: newRows
      }
    };
  });
}


  setSiteMap(cartId: string) {
    // const selecttrip = this.global.getSelectedTrip();
    const selectrip = this._global.getSelectedTrip();
    this.airplane = selectrip.aircraftType;
    this.airplane = this.airplaneMap = this.seatsServ.aircraftTypeMap(this.airplane)
    console.log("Avion: ",this.airplane)
    this.seatMapSections = this.sectionRow();
  }

  loadMapInit() {
    // this.seatMap = this.global.getSeatMapInfo()
    this.seatMap = this._global.getSeatMapInfo();
    const cartId = this._global.getReservation().flightSummary.cartId;
    this.setSiteMap(cartId);
  }


  loadMapAirplane(styleMap: AirplaneStyle) {
    this.mapDiv = document.querySelector('#airplane');
    let styles = 'background: no-repeat;';
    for (const [key, value] of Object.entries(styleMap)) {
      if (value !== '') {
        styles += `${key}: ${value};`;
      }
    }
    this.mapDiv?.setAttribute('style', styles);
  }

  validateShowDiv(value) {
    if (value == 'nav') {
      if (this.navTab == false) {
        this.navTab = true
        this.showDiv = true;

      } else {
        this.showDiv = false;
        this.navTab = false
      }
    } else {
      if (this.footerTab == false) {
        this.footerTab = true
        this.showDiv = true;

      } else {
        this.showDiv = false;
        this.footerTab = false
      }
    }
  }

  nextPassenger() {
    const positionCurrentPassenger = this.passengerSelect.getPositionCurrentPassenger();
    this.nextPosition = positionCurrentPassenger + 1;
    if (this.passengers.length == this.nextPosition) {
      this.passengerSelect.setPositionCurrentPassenger(0)
      this.router.navigate(['/seat'])
    } else {
      this.passengerSelect.setPositionCurrentPassenger(this.nextPosition)
      this.currentPassenger = this.passengerSelect.getCurrentPassenger();
      this.loadMapInit()
    }
  }

  validateCheck(checkstatus) {
    this.totalSeatsPassengers = 0;
    const positionCurrentPassenger = this.passengerSelect.getPositionCurrentPassenger();
    this.nextPosition = positionCurrentPassenger
    this.currentPassenger = this.passengerSelect.getCurrentPassenger();
    this.passengers.map(x => {
      const seats = x.seats.filter(seat => seat.status == 3 && seat.segmentCode == this.selectedTrip.segmentCode);
      seats?.map(x => {
        this.totalSeatsPassengers += +x.cost;
      })
    });
    return false
  }

  validateTypeSeat(seat, segment) {
    if (seat.length = 0) {
      return ""
    } else {
      let seatMaps
      let seatName
      seatMaps = this.seatMap.find(seatMapp => seatMapp.segment.segmentCode === segment.segmentCode);
      const foundSeat = seat.find(element => element.SegmentCode === segment.segmentCode);
      if (foundSeat) {
        seatName = foundSeat.code;
      }
      let seatDistributionCollection = seatMaps.seatDistributionCollection.seatDistributions
      let response: any
      seatDistributionCollection.map(x => {
        x.columns.map(y => {
          if (y.code == seatMaps?.seatMap[seatName]?.column) {
            response = { code: y.code, type: y.seatCharacteristics }
          }
        })
      })
      if (response != undefined) {
        if (response.type != null)
          response.type = response.type[0]
        response = this.asignateTypeSeat(response)
        return response
      } else {
        return ''
      }

    }
  }

  getCodeSeat(seat, segment, select) {
    let name = ''
    let type = ''
    const foundSeat = seat.find(element => element.segmentCode === segment.segmentCode);
    if (foundSeat) {
      name = foundSeat.code;
      type = foundSeat.type;
    }
    switch (select) {
      case 'code':
        return name
        break;
      case 'type':
        return type
        break;
      default:
        return ''
        break
    }
  }

  getCostSeat(seat, segment) {
    let cost = 0
    const foundSeat = seat.find(element => element.segmentCode === segment.segmentCode);
    cost = foundSeat?.currency?.total;
    return cost
  }

  asignateTypeSeat(response) {
    let text = null;
    switch (response.type) {
      case 'Aisle':
        text = 'seatReview.aisle'
        break;
      case 'Window':
        text = 'seatReview.window'
        break;

      default:
        text = 'seatReview.middle'
        break;
    }
    return text
  }

}

